"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const WidgetArea_1 = require("./impl/WidgetArea");
const $ = require('jquery');
class SideBar extends React.Component {
    constructor(props) {
        super(props);
        this.sidebar = React.createRef();
    }
    componentDidMount() {
        if (process.title === 'browser') {
            $(this.sidebar.current).parent().theiaStickySidebar({
                updateSidebarHeight: !0,
            });
        }
    }
    render() {
        return (React.createElement("div", { className: 'col-md-3' },
            React.createElement("div", { className: 'sidebar sidebar-right', ref: this.sidebar },
                React.createElement(WidgetArea_1.default, { name: 'sidebar' }))));
    }
}
exports.default = SideBar;
